var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-main"},[_c('outboxCon',[_c('div',{staticClass:"teach-quality"},[_c('ul',{staticClass:"teach-quality-ul"},_vm._l((_vm.imgConfig),function(item,i){return _c('li',{key:i},[_c('img',{staticClass:"icon-quality",attrs:{"src":item.imgUrl,"alt":item.desc}})])}),0)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }